<template>   
    <div class="container"> 
    <v-btn small fab color="white" router to="/dashboard" >
       <v-icon medium color="red">close</v-icon>    
    </v-btn>
    <v-btn v-if="docRef"  color="indigo" @click="e1 = 3" >
        <v-icon left medium color="white" >people_outline</v-icon>
        <span right class="white--text">Add New</span>
    </v-btn>
  <v-card> 

  <v-stepper v-model="e1" class="grey lighten-4" >
    <v-stepper-header>
      <v-stepper-step :complete="e1 > 1" step="1">TRAINING</v-stepper-step>
    
      <v-divider></v-divider>

      <v-stepper-step :complete="e1 > 2" step="2">TRAINER</v-stepper-step>

      <v-divider></v-divider>

      <v-stepper-step :complete="e1 > 3" step="3">PARTICIPANTS</v-stepper-step>
      <v-divider></v-divider>

      <v-stepper-step step="4">REVIEW & SUBMIT</v-stepper-step>
    </v-stepper-header>
    
    <v-stepper-items>
      <v-stepper-content step="1">
        <v-divider></v-divider>
        <v-alert :value="true" v-if="correct" type="success">{{alertmsg}} </v-alert>
        <v-alert :value="true" v-if="wrong" type="error"> {{alertmsg}}  </v-alert>
        <v-card class="pa-3 teal lighten-5">
        <v-form ref="form1" v-model="valid" lazy-validation>
          <h1><v-text-field color="teal" @click="wrong = false" prepend-inner-icon="assignment" v-model="name" label="Title of the training activity" hint="Please give a title that explains what the type of training activity" :rules="inputRules"></v-text-field></h1>                         
          <v-menu v-model="menu" :close-on-content-click="false">
              <v-text-field slot="activator" :rules="inputRules"
                :value="formattedDate" clearable label="Start date" prepend-icon="date_range">
              </v-text-field>
              <v-date-picker v-model="due" @change="menu = false"></v-date-picker>
          </v-menu>       
          <v-menu v-model="menu1" :close-on-content-click="false">
              <v-text-field slot="activator"  :rules="inputRules"
                :value="formattedDate1" clearable label="End date" prepend-icon="date_range">
              </v-text-field>
              <v-date-picker v-model="due1" @change="menu1 = false"></v-date-picker>
          </v-menu>
            <h1><v-text-field v-model="mobiliser" clearable label="Full Name of the local HRD who mobilized the participants for the training" prepend-icon="person" :rules="inputRules"></v-text-field></h1>
        </v-form>
        </v-card>
        <v-card class="pa-3">
          <v-container fluid>
            <h3 class="grey darken-3 white--text pa-2">
                <v-dialog v-model="rdialog" max-width="400">
                  <v-card class="pa-3">
                    <v-card-title class="headline">New {{additem}} Category</v-card-title>
                      <v-form v-model="valid" lazy-validation>
                        <v-text-field  v-model="ttype"  :counter="50" hint="Please only add if the new category does not match the list given on the form"  label="Add a new category"  required></v-text-field>
                      </v-form>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                        color="green darken-1"            
                        @click="addCategory"
                      >
                        Submit
                      </v-btn>

                      <v-btn
                        color="green darken-1"
                        @click="rdialog = false"
                      >
                        Cancel
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
             <v-icon class="red white--text" @click="rdialog = true, additem='Training'">add_box</v-icon>              
              Which areas did the training cover?
            </h3>
            <v-card class="pa-3">
             <v-form ref="form2" v-model="valid" lazy-validation>                
              <v-layout row wrap="true" >                          
                <v-checkbox v-model="tcategory"  v-for="selects in selected"
                  :key="selects.id" :label="selects.category" :value="selects.category">                         
                </v-checkbox>                                          
            </v-layout> 
             </v-form>
            </v-card>       
          <h3 class="grey darken-3 white--text pa-2">
          <v-icon class="white--text">done_all</v-icon>
            Where do you classify this training? An intermediate training is for participants who participated in a similar training before.</h3>
          <v-flex xs12 wrap="true">
            <v-radio-group v-model="level" row>
              <v-radio
                v-for="(colorValue, i) in ['Beginner', 'Intermediate', 'Advanced(Training of Trainers)']"
                :key="i"
                :color="success"
                :label="colorValue"
                :value="colorValue"
              ></v-radio>
            </v-radio-group>
          </v-flex>
         
          </v-container>
        </v-card>

        <v-btn
          color="teal"
          @click="e1 = 2"
          class="white--text"
        >
          Continue
        </v-btn>
      </v-stepper-content>

      <v-stepper-content step="2">
        <v-card v-if="!saved">
          <h3 class="grey darken-3 white--text pa-1">
              <v-dialog
                  v-model="tdialog"
                  max-width="800"
                >
                <h4 class="headline teal white--text pa-2"> New Trainer Bio-Data</h4>
                  <v-card class="pa-3">
                    
                    <v-card-title class="headline">Please complete this form to submit a new trainer</v-card-title>
                     <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                        color="green darken-1"            
                        @click="addTrainer"
                      >
                        Submit
                      </v-btn>
                      <v-btn
                        color="green darken-1"
                        @click="tdialog = false"
                      >
                      Cancel
                      </v-btn>
                    </v-card-actions>
                     <h3 class="grey darken-3 white--text pa-2">
                        Name and Contact details
                      </h3>
                      <v-form ref="form3" v-model="valid" lazy-validation>
                        <v-text-field v-model="contact" label="Name of the Trainer" prepend-icon="contacts" :rules="inputRules"></v-text-field>
                        <v-text-field v-model="email" label="Email Address" prepend-icon="contact_mail" :rules="emailRules"></v-text-field>
                        <v-text-field v-model="phone" label="Mobile Number" prepend-icon="contact_phone" :rules="inputRules"></v-text-field>
                        
                        <h3 class="grey darken-3 white--text pa-2">Areas of Expertise (This trainer is experienced in the following areas)</h3>
                        <v-layout row wrap>              
                            <v-checkbox v-model="tarea"  v-for="selects in selected"
                              :key="selects.id" :label="selects.category" :value="selects.category">                         
                            </v-checkbox>                               
                          </v-layout> 
                      <h3 class="grey darken-3 white--text pa-2">
                        Affiliation to your organisation
                        </h3> 
                        <v-layout row wrap="true">
                          <v-checkbox v-model="trainer" label="Staff Member" value="Staff Member"></v-checkbox>
                          <v-checkbox v-model="trainer" label="Freelance Consultant" value="Freelance Consultant"></v-checkbox>
                          <v-checkbox v-model="trainer" label="Pro Bono" value="Pro Bono"></v-checkbox>
                          <v-checkbox v-model="trainer" label="Other" value="Other"></v-checkbox>          
                      </v-layout> 
                    </v-form>
                    
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                        color="green darken-1"            
                        @click="addTrainer"
                      >
                        Submit
                      </v-btn>
                      <v-btn
                        color="green darken-1"
                        @click="tdialog = false"
                      >
                      Cancel
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
           Select or Add trainer(s)
        </h3> 
        <v-card  flat v-for="(train, i) in trainers" :key="train.id">
          <v-layout v-if="!saved" row wrap>          
              <v-flex xs12 md4 class="teal lighten-5 ">           
                <div class="pa-1">                   
                  <h4>{{i+1}}. {{train.tname}}, {{train.reference}}</h4>
                  <div class="pl-3">{{train.tarea}} trainer</div>
                  <div class="pl-3" v-for="trainer in train.specialisation" :key="trainer.id">
                     {{trainer}}
                  </div>                  
                </div>                      
              </v-flex>
              <v-flex xs12 md4 class="teal lighten-5 ">            
                <div class="">Mobile: {{train.tphone}}  </div>
                <div class="">Email: {{train.temail}}</div>                       
              </v-flex>
              <v-flex xs12 md4 class="teal lighten-5">            
                <v-checkbox class="pa-0" @change="selectTrainer(train.id)"></v-checkbox>    
              </v-flex>          
          </v-layout>
          <v-divider class="grey"></v-divider>
        </v-card>  
        <v-alert v-if="correct" :value="true" color="green">{{alertmsg}}</v-alert>
        <v-alert v-if="wrong" :value="true" color="red">{{alertmsg}}
            <v-btn v-if="!saved" flat @click="e1 = 1, wrong=false">Back</v-btn>
        </v-alert>  
        <v-container fluid class="grey lighten-1"> 
        <v-btn small color="indigo darken-4" @click="tdialog = true"> 
           <h4 class="white--text pa-1"> Add a new trainer</h4>           
            <v-icon medium color="white">add_box</v-icon>           
        </v-btn> 
       </v-container>                              
       </v-card>
        <v-alert v-if="saved" :value="true" color="green">
          Your data has been successfull saved.
          Please add training Participants
          <v-btn @click="e1 = 3; {{saved=false}}">Add Participants</v-btn>
        </v-alert>
        <v-btn
          v-if="!saved"
          color="teal"
          @click="addTraining"       
          class="white--text"
        >
         next
        </v-btn>
      <v-btn v-if="!saved" flat @click="e1 = 1">Back</v-btn>

      </v-stepper-content>
      <v-stepper-content step="3">
        <h3 class="grey darken-3 white--text pa-2">
            <v-icon class="white--text">person_pin</v-icon>
          Participants Details         
        </h3>
        <v-card v-if="!success">
          <v-text-field v-model="pname" label="Full Names:" prepend-icon="person" :rules="inputRules"></v-text-field>
          <v-text-field v-model="porg" label="Organisation name:" prepend-icon="business" :rules="inputRules"></v-text-field>
          <v-text-field v-model="pemail" label="Email Address:" prepend-icon="email" :rules="emailRules"></v-text-field>
          <v-text-field v-model="pphone" label="Mobile No:" prepend-icon="phone" :rules="inputRules"></v-text-field>
          <v-text-field v-model="county" label="County of work" prepend-icon="location_on" :rules="inputRules"></v-text-field>
          <v-text-field v-model="area" label="Town/Village where the HRDs works" prepend-icon="person_pin_circle" :rules="inputRules"></v-text-field>                
          <h3 class="grey darken-3 white--text pa-2">
            <v-icon class="white--text" @click="rdialog = true, additem='Human Rights'">add_box</v-icon>
           Select the Human Rights Issues/Themes the participant works on           
          </h3>
          <v-flex xs12 wrap="true">
          <v-layout  wrap="true">                                 
              <v-checkbox v-model="rcategory"  v-for="rcatg in rights"
                :key="rcatg.id" :label="rcatg.category" :value="rcatg.category">                         
              </v-checkbox>                                                     
          </v-layout>
          </v-flex>
       </v-card>
        <v-alert :value="true" v-if="success" color="green">
           Participant Details have been successfully saved. 
          <v-btn color="teal"  @click="success = false" class="white--text" > Add another participant  </v-btn>
          <v-btn color= "teal" router to="/projects" class="white--text">Finish</v-btn>
        </v-alert>
        <v-btn color="teal" v-if="!success" @click="addTrainee" class="white--text" > Save  </v-btn>        
      </v-stepper-content>

      <v-stepper-content step="4">
        <v-card>
           <h2 class="grey darken-3 white--text"> {{name}}</h2>
           <h5>Training Period: from {{due}}  to  {{due1}} </h5>
           <v-divider class="grey lighten-1"></v-divider>
           <h3>Human Rights Areas covered by Participants</h3> 
              <span>{{rcategory}}   </span> 
             <v-divider class="grey lighten-1"></v-divider>
            <h3>Areas covered by the Training</h3> 
              <span>{{tcategory}}   </span>
              <v-divider class="grey lighten-1"></v-divider>
            <h3>Level of Training</h3> 
              <span>{{level}}   </span>  
             <v-divider class="grey lighten-1"></v-divider>  
             <h3>Trainer Details</h3> 
              <span>Name: {{contact}}   </span>
              <v-divider class="grey lighten-1"></v-divider> 
              <span>Emails: {{email}}   </span> 
              <v-divider class="grey lighten-1"></v-divider>
              <span>Mobile: {{phone}}   </span> 
              <v-divider class="grey lighten-1"></v-divider>
              <span>Affiliation to Organization: {{trainer}} </span>
              <v-divider class="grey lighten-1"></v-divider>
             <h3>County and location where HRDs covered by the training work</h3>               
              <span>{{area}} , {{county}}   </span>                 
        </v-card>
        <v-btn
          color="teal"
          class="white--text"
          @click="addTrainee"
        >
         Submit
        </v-btn>
         <v-btn flat @click="e1 = 1">Edit</v-btn>       
      </v-stepper-content>
    </v-stepper-items>
  </v-stepper>
</v-card>
</div>
</template>
    
<script>
import format from 'date-fns/format'
import {db, auth, functions, auth2} from '@/fb'
import router from '../router.js'

export default {
  data() {
    return {
      e1: 0,
      //TRAINING
        userid: '', 
        additem: '',
        ttype: '',
        hrtheme: '',
        email: '',
        county: '',
        area: '',
        mobiliser:'',
        due: null,
        due1: null,
        phone:'',
        tcategory: [],
        rcategory: [],
        rights: [],
        updateAction: false,
      //PARTICIPANTS         
        name: '',
        contact: '',
        userdata : [],
        level: '',
        pname: '',
        pemail: '',
        pphone:'',
        porg: '',
      //TRAINERS
        tdialog: false,
        selected: [],
        trainer: [],
        trainers: [],
        temail: '',
        tphone: '',
        tcontact: '',
        tname: '',
        item: '',
        tarea: [],
      //SETTINGS
        next: '',
        valid: '',
        info: '',
        drawer: false,
        menu: false,
        admin: false,
        success: '',
        color: '',
        saved: false,
        correct: false,
        wrong: false,
        alertmsg: '',
        eTrainer: '',
        docRef: false,
        docuid: '',
        menu1: false,
        loading: false,
        indialog: false,
        loggedIn: false,
        snackbar: false,
        outdialog: false,
        rdialog: false,
      inputRules: [
        v => !!v || 'This field is required',
        v => v.length >= 5 || 'Minimum length is 5 characters'
      ],
      passRules: [
        v => !!v || 'This field is required',
        v => v.length >= 8 || 'Minimum length is 8 characters'
      ],
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+/.test(v) || 'E-mail must be valid'
      ]
    }
  },
  computed: {
      
  },
  methods: {
    addCategory() {
            var catg = ''
            if (this.additem =='Human Rights') {
                catg = 'r_categories'
            } 
            if (this.additem =='Training') {
                catg = 't_categories'
            }
            if (this.ttype !='') {
                db.collection(catg).doc().set({
                    category: this.ttype              
                }).then( () => {
                        this.rdialog = false
                        this.ttype = ''
                        //router.push({ path: 'profile' })
                });
            }   
    },
    addTheme() {
        db.collection("hr_themes").doc().set({
              category: this.hrtheme             
        })
        .then( () => {             
              this.rdialog = false
              //router.push({ path: 'profile' })
        });  
    },
    editTrainer: function(eTrainer) {
        this.eTrainer = eTrainer;
        console.log(this.eTrainer)
    },
    show1() {

    },
    selectTrainer(selectItem) {
       this.item = selectItem      
       db.collection('trainers').get().then
       (querySnapshot => {
         querySnapshot.forEach(doc => {
           if (doc.id == this.item) {         
              this.tcontact = doc.data().tname
              this.temail = doc.data().temail
              this.tphone = doc.data().tphone
              this.reference = doc.data().reference
              this.trainer = doc.data().reference
              this.tarea = doc.data().specialisation           
           }              
         })
      });     
    },
    addTrainer() {
       db.collection("trainers").add({
            reference : this.reference,
            type : this.tcategory,
            tname: this.contact,
            tphone : this.phone,
            temail: this.email,
            specialisation: this.tarea,
            affiliation: this.trainer
        })
        .then( (docRef) => {
          this.tdialog = false          
        }); 

    },
    addTraining() {
      if(this.$refs.form1.validate())  { 
        if (this.tcategory != '') {
          if (this.level != '') {
            if (this.item != '') {  
              var action = ''
             if (this.updateAction == false) {
               db.collection("trainings").add({
                    reference : this.reference,
                    title : this.name,
                    type : this.tcategory,
                    tname: this.tcontact,
                    tphone : this.tphone,
                    temail: this.temail,
                    taffiliation: this.trainer,
                    mobiliser : this.mobiliser,
                    startdate : this.due,
                    enddate : this.due,
                    docRef: this.docuid,
                    level : this.level
                })
                .then( (docRef) => {           
                    db.collection("trainings").doc(docRef.id).update({
                      "docRef": docRef.id
                    }).then( () => { 
                      this.correct = true
                      this.wrong = false
                      this.alertmsg = "Training successfully added to the database"
                      this.docRef = true
                      this.docuid = ''
                      this.saved = true       
                    }); 
                }); 
              }else{ 
                db.collection("trainings").doc(this.$route.params.ref).update({
                    title : this.name,
                    type : this.tcategory,
                    tname: this.tcontact,
                    tphone : this.tphone,
                    temail: this.temail,
                    taffiliation: this.trainer,
                    mobiliser : this.mobiliser,
                    startdate : this.due,
                    enddate : this.due,
                    docRef: this.$route.params.ref,
                    level : this.level
                })
                .then( (docRef) => {
                    this.alertmsg = "Training Details updated Successfully"
                    this.correct = true
                    this.wrong = false
                });
              }
            } else {
              this.alertmsg = "Please select the facilitator(s) of the training "+this.tcontact+' '+this.trainer
              this.correct = false
              this.wrong = true
            }              
          }else {  
            this.alertmsg = "You did not select the level of  Training in previous step"
            this.correct = false
            this.wrong = true     
          }          
        } else {
           this.alertmsg = "You did not select the type of training in the previous step"
           this.correct = false
           this.wrong = true   
        } 
       } else {
         this.alertmsg= "Incomplete details in the previous step"
         this.correct = false
         this.wrong = true  
       }    
      },
      addTrainee() {
        if (this.docRef != "") {         
            db.collection("participants").doc().set({
                "refno": this.docuid,
                "p_name": this.pname,
                "p_phone": this.pphone,
                "p_email": this.pemail,
                "p_org": this.porg,
                "county": this.county,
                "area": this.area,
                "theme": this.rcategory,
                "level" : this.level,
                "category" : this.tcategory
            })
            .then( () => {           
                this.wrong = false
                this.success = true
                this.docuid,
                //RESET
                this.pname = ''
                this.pphone = ''
                this.pemail = ''
                this.porg = ''
                this.county = ''
                this.area = ''
                this.rcategory = ''
                this.level = ''
                //router.push({ path: 'projects' })
            }); 
        } else {
          this.wrong = true
          this.alertmsg = "Please add a training first"
          console.log(alertmsg)
        }  
      }
  },
  created() {
      if (auth.currentUser == null) {
          this.$router.push({ name: "home" });
      }
      this.success = false
      var option = this.$route.params.ref
      if (typeof option === 'undefined') {
        this.updateAction = false
      }else{
        this.updateAction = true
        db.collection('trainings').get().then
        (querySnapshot => {
            querySnapshot.forEach(doc => {         
                if (option == doc.id) {
                  this.name = doc.data().title
                  this.tcategory = doc.data().type
                  this.tcontact = doc.data().tname
                  this.temail = doc.data().temail
                  this.tphone = doc.data().tphone
                  this.ttype = doc.data().ttype
                  this.trainer = doc.data().reference
                  this.tarea = doc.data().specialisation
                  this.mobiliser  = doc.data().mobiliser
                  this.due  = doc.data().startdate
                  this.due1  = doc.data().enddate
                  this.level  = doc.data().level
                  this.docuid = doc.data().docRef
                }                    
            })
        });
      }
      this.userid = auth.currentUser.uid
      db.collection('members').get().then
      (querySnapshot => {
          querySnapshot.forEach(doc => {         
              if (this.userid == doc.id) {
                this.reference = doc.data().name 
              }                    
          })
      });
      
      db.collection('trainers').onSnapshot(res => {
        const changes = res.docChanges();
        changes.forEach(change => {
          if (change.type === 'added') {
            this.trainers.push({
              ...change.doc.data(), 
              id: change.doc.id
            })
          }  
        })
      });

      db.collection('t_categories').onSnapshot(res => {
        const changes = res.docChanges();
        changes.forEach(change => {
          if (change.type === 'added') {
            this.selected.push({
              ...change.doc.data(), 
              id: change.doc.id
            })
          }  
        })
      })

      db.collection('r_categories').onSnapshot(res => {
        const changes = res.docChanges();
        changes.forEach(change => {
          if (change.type === 'added') {
            this.rights.push({
              ...change.doc.data(), 
              id: change.doc.id
            })
          }  
        })
      })      
  },
  computed: {
    formattedDate () {
      return this.due ? format(this.due, 'Do MMM YYYY') : ''
    },
    formattedDate1 () {
      return this.due1 ? format(this.due1, 'Do MMM YYYY') : ''
    }
  }
}
</script>
